import {
  FilteredResource,
  PredefinedFunctions,
  ResourcePermissions,
  Role,
} from 'model/role-permissions';
import { Themes } from 'theme/themes';

export interface AuthContextAction {
  type: string;
  payload?: any;
}

export interface AuthContextUser {
  email: string;
  person_id: string;
  roles: string[];
  impersonatedRoles?: string[];
  // Cross-workspace user-impersonation (prod1 → prod). When set,
  // `impersonatedUser` is the target's email and `impersonatorUsername`
  // is the real operator's email. Both come from the backend's
  // `permissions_read` response.
  impersonatedUser?: string;
  impersonatorUsername?: string;
  /* The target's person id while borrowing a prod user (see effectivePersonId). */
  impersonatedPersonId?: string;
  /* This permissions replace all the functions with the actual permission */
  ownPermissions: ResourcePermissions;
  /* This permissions are the ones saved in bd */
  realPermissions: ResourcePermissions;
  roleData: Role[];
  subRoles: Role[];
  resources: string[];
  theme: Themes;
  predefinedFunctions?: PredefinedFunctions[];
  filteredResources?: FilteredResource;
  permission_groups: string[],
  alternate_email?: string;
}

export interface AuthContextState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: AuthContextUser | null;
}

export const AUTH_CONTEXT_HANDLERS = {
  INITIALIZE: 'INITIALIZE',
  FETCH_PERMISSIONS: 'FETCH_PERMISSIONS',
  SIGN_OUT: 'SIGN_OUT',
  IMPERSONATE: 'IMPERSONATE',
};
